/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-10 17:19:58
 */
import { defineMessages } from 'react-intl';

const object: { [key: string]: string } = {
  downloadLog: '日志下载',
  failedInstall: '安装失败',
  failedUpgrade: '升级失败',
  failedUninstall: '卸载失败',
  detail: '详情',
  installing: '正在安装',
  upgrading: '正在升级',
  uninstalling: '正在卸载',
  waiting: '正在等待',
  reInstall: '重新安装',
  reUnInstall: '重新卸载',
  reUpgrading: '重新升级',
  cancel: '取消',
  successInstall: '安装成功',
  successUpgrade: '升级成功',
  moduleUninstallTip: '请确定卸载{name} ?',
  itemPaused: '{type}已暂停',
  pausedTip: '（组件{type}，依赖supOS{type}成功）',
  install: '安装',
  upgrade: '升级',
  uninstall: '卸载',
  continue: '继续',
  status: '状态',
  host: '所在主机',
  instalDate: '安装时间',
  notInstall: '未安装',
  running: '运行中',
  starting: '启动中',
  restarting: '重启中...',
  stopped: '已停止',
  pending: '启动中...',
  runNing: '正在运行',
  stopping: '停止中...',
  notinstall: '未安装',
  paused: '已暂停',
  stop: '停止',
  start: '启动',
  rollBack: '回滚',
  rolling_back: '回滚中',
  failedRollBack: '回滚失败',
  disturbance: '有扰升级',
  undisturbed: '无扰升级',
};
export default defineMessages(object);
